import script from "./PCPartsItemCardBodySecondaryActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsItemCardBodySecondaryActions.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsItemCardBodySecondaryActions.vue?vue&type=style&index=0&id=3b293d15&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b293d15"]])

export default __exports__